import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getPatientReports,
  createPatientReport,
  getSignedUrl,
  saveMessageAsReport,
} from "../api/reports"

export const useFetchPatientReports = (patientId, offset, limit) => {
  return useQuery({
    queryKey: ["patient-reports", patientId, offset, limit],
    queryFn: () => getPatientReports({ patientId, offset, limit }),
    select: (response) => ({
      reports: response.data.data.reports,
      pagination: {
        total: response.data.data.total,
        totalPages: Math.ceil(response.data.data.total / limit),
      },
    }),
    enabled: !!patientId,
  })
}

export const useCreatePatientReport = (patientId) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data) => createPatientReport(patientId, data),
    onSuccess: () => {
      queryClient.invalidateQueries(["patient-reports", patientId])
    },
  })
}

export const useGetSignedUrl = (filePath, enabled = false) => {
  return useQuery({
    queryKey: ["signed-url", filePath],
    queryFn: () => getSignedUrl(filePath),
    select: (response) => response.data.data.public_link[0],
    enabled: !!filePath && enabled,
    staleTime: 0,
    cacheTime: 0,
    refetchOnWindowFocus: false,
  })
}

export const useSaveMessageAsReport = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ patientId, data }) => saveMessageAsReport(patientId, data),
    onSuccess: (_, { patientId }) => {
      // Invalidate patient reports to refresh the list
      queryClient.invalidateQueries(["patient-reports", patientId])
    },
    onError: (error) => {
      console.error("Failed to save message as report:", error)
      throw error // Re-throw to let the component handle the error
    },
  })
}
